<script>
export default {
  name: 'ErrorState',
  props: {
    title: { type: String, default: 'Something went wrong' },
    message: { type: String, default: 'Please try again later or contact support.' },
  },
};
</script>

<template>
  <div class="error-state py-16 px-1 ml-0 mr-0">
    <h3
      v-if="title"
      class="text-red-600 dark:text-red-400 block text-center w-full text-xl font-semibold"
    >
      {{ title }}
    </h3>
    <p
      v-if="message"
      class="block text-center text-slate-600 dark:text-slate-300 my-4 mx-auto w-[90%]"
    >
      {{ message }}
    </p>
    <slot />
  </div>
</template>

<style scoped>
.error-state {
  background-color: rgba(255, 0, 0, 0.03);
  border-radius: 0.5rem;
}
</style>
